import { Bar, BarChart, CartesianGrid, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { RAIN_TH, localTime } from "@/lib/weather";
import { useT } from "@/lib/i18n";

const tick = { fill: "#64748B", fontSize: 10, fontFamily: "JetBrains Mono, monospace" };

export const MinutelyChart = ({ data }) => {
  const { t } = useT();
  const now = Date.now() / 1000;
  const rows = (data.minutely || []).map((m) => ({ min: Math.round((m.dt - now) / 60), mm: m.precipitation || 0, time: localTime(m.dt, data.timezone_offset) }));
  return (
    <section data-testid="weather-minutely" className="bg-[#12141C] border border-[#282D3D] rounded-sm p-4">
      <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500 mb-2">{t("wx_next_60")}</div>
      {rows.length === 0 ? <div className="font-mono text-xs text-slate-500 py-8 text-center">{t("wx_no_minutely")}</div> : (
        <div className="h-[150px]">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={rows} margin={{ top: 5, right: 5, bottom: 0, left: -20 }}>
              <CartesianGrid stroke="#282D3D" strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="min" tick={tick} stroke="#282D3D" interval={9} tickFormatter={(v) => `+${Math.max(0, v)}'`} />
              <YAxis tick={tick} stroke="#282D3D" domain={[0, (max) => Math.max(1, Math.ceil(max))]} unit="" />
              <ReferenceLine y={RAIN_TH} stroke="#FFB800" strokeDasharray="4 3" />
              <Tooltip cursor={{ fill: "#ffffff10" }} contentStyle={{ background: "#0B0D13", border: "1px solid #282D3D", fontFamily: "JetBrains Mono, monospace", fontSize: 11 }}
                labelFormatter={(_, p) => p?.[0]?.payload?.time} formatter={(v) => [`${v.toFixed(2)} mm/h`, t("wx_rain")]} />
              <Bar dataKey="mm" fill="#007AFF" isAnimationActive={false} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </section>
  );
};
